import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCategoryMenu } from "@/components/@common/CategoryMenu/hooks/useCategoryMenu";
import { useAdBannerQuery } from "@/components/Banner/AdBanner";
import { SideSheetSteps } from "@/components/SideSheets/GNBSideSheet";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Typography } from "@bookips/sds";
import { Box as MuiBox } from "@mui/material";
import Link from "next/link";
import { SideSheetHeader, SideSheetUtils } from ".";
import { MenuColumn } from "../Category";
import useCategorySideDepth from "../Category/hooks/useCategorySideDepth";
import { BoxContainer, BoxTitle, MenuLinkBox, RowContainer } from "../Category/index.style";
import Icon from "../icon/Icon";
import { ArrowRight, Sizes } from "../icon/IconList";
import { useSideCategoryMenuStore } from "./store/useCategoryMenuStore";
//SideSheetSteps.default
export const SideSheetDefaultStep = (param)=>{
    let { goToNextStep , onClose  } = param;
    var _adBannerResponse_items, _firstBanner_link;
    const { adBannerResponse  } = useAdBannerQuery({
        position: "sidesheet"
    });
    const { menuFooter  } = useCategoryMenu();
    const shortcutMenuMixpanel = (title, url)=>{
        mixpanelEvent("Side Sheets Footer Clicked", {
            "Button Name": title,
            "Button Url": url
        });
    };
    const firstBanner = adBannerResponse === null || adBannerResponse === void 0 ? void 0 : (_adBannerResponse_items = adBannerResponse.items) === null || _adBannerResponse_items === void 0 ? void 0 : _adBannerResponse_items[0];
    return /*#__PURE__*/ _jsx("div", {
        className: "flex h-[calc(var(--vh,1vh)*100)] flex-col justify-between max-lg:h-[calc(var(--vh,1vh)*100-64px)]",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex h-full flex-col",
            children: [
                /*#__PURE__*/ _jsx(SideSheetHeader, {
                    title: "메뉴",
                    onClose: onClose,
                    currentStep: SideSheetSteps.default
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex-1 overflow-y-auto",
                    children: [
                        /*#__PURE__*/ _jsx(SideSheetUtils, {
                            goToNextStep: goToNextStep
                        }),
                        firstBanner && /*#__PURE__*/ _jsx(Link, {
                            href: firstBanner.link,
                            target: ((_firstBanner_link = firstBanner.link) === null || _firstBanner_link === void 0 ? void 0 : _firstBanner_link.includes("https://solvook.com")) ? "_self" : "_blank",
                            onClick: ()=>mixpanelEvent("AD Banner Clicked", {
                                    ID: firstBanner.id,
                                    "Button URL": firstBanner.link,
                                    position: "side sheets"
                                }),
                            className: "mb-5 flex h-16 w-full items-center justify-center overflow-hidden bg-gray-400/20",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: firstBanner.imageUrl,
                                alt: "광고 이미지",
                                className: "block max-h-16 max-w-[250px] object-contain"
                            })
                        }),
                        menuFooter.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "subtitle2",
                                    className: "text-strong mb-2 block px-5",
                                    children: "바로가기"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "flex flex-col gap-2 px-5 pb-5",
                                    children: menuFooter.map((item)=>/*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsxs(Link, {
                                                href: item.itemLink,
                                                onClick: ()=>shortcutMenuMixpanel(item.itemTitle, item.itemLink),
                                                className: "bg-gray-0 flex items-center justify-between rounded-md p-3 hover:bg-gray-50",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Typography, {
                                                        variant: "subtitle2",
                                                        className: "text-strong",
                                                        children: item.itemTitle
                                                    }),
                                                    /*#__PURE__*/ _jsx(Icon, {
                                                        icon: ArrowRight,
                                                        size: Sizes.small
                                                    })
                                                ]
                                            })
                                        }, item.itemSeq))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
//SideSheetSteps.menuList
export const SideSheetMenuListStep = (param)=>{
    let { goToPrevStep , onClose  } = param;
    var _depthData_two, _depthData_three, _depthData_four, _depthData_four1;
    const { depthData  } = useCategorySideDepth();
    const { threeDepthIdInStore , setState  } = useSideCategoryMenuStore((state)=>({
            threeDepthIdInStore: state.threeDepthId,
            setState: state.setState
        }));
    const categoryMenuMixpanel = (depth, title, url)=>{
        mixpanelEvent("Category Menu Clicked", {
            Depth: depth,
            "Menu Name": title,
            Url: url
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SideSheetHeader, {
                title: "".concat((_depthData_two = depthData.two) === null || _depthData_two === void 0 ? void 0 : _depthData_two.name, " - ").concat(depthData.three.name) || "",
                onClose: onClose,
                currentStep: SideSheetSteps.menuList,
                goToPrevStep: goToPrevStep
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "h-[calc(100vh-58px)] max-h-[calc(var(--svh,1svh)*100-58px)] max-lg:h-[calc(100vh-58px-64px)] max-lg:max-h-[calc(var(--svh,1svh)*100-58px-64px)]",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex h-full",
                    children: [
                        /*#__PURE__*/ _jsx(MenuLinkBox, {
                            className: "link-box-mobile _depth-two",
                            children: /*#__PURE__*/ _jsx(RowContainer, {
                                className: "container-mobile",
                                children: /*#__PURE__*/ _jsx(BoxContainer, {
                                    children: (_depthData_three = depthData.three) === null || _depthData_three === void 0 ? void 0 : _depthData_three.items.map((item)=>/*#__PURE__*/ _jsx(MenuColumn, {
                                            data: item,
                                            onColumnClick: ()=>{
                                                setState("threeDepthId", item.id);
                                                categoryMenuMixpanel("three", item.name, "");
                                            },
                                            isActive: item.id === threeDepthIdInStore
                                        }, item.id))
                                })
                            })
                        }),
                        depthData && /*#__PURE__*/ _jsxs(MenuLinkBox, {
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "/categories?id=".concat((_depthData_four = depthData.four) === null || _depthData_four === void 0 ? void 0 : _depthData_four.id),
                                    children: /*#__PURE__*/ _jsx(BoxTitle, {
                                        children: /*#__PURE__*/ _jsxs(MuiBox, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px"
                                            },
                                            children: [
                                                ((_depthData_four1 = depthData.four) === null || _depthData_four1 === void 0 ? void 0 : _depthData_four1.name) || "",
                                                /*#__PURE__*/ _jsx(Icon, {
                                                    icon: ArrowRight,
                                                    size: Sizes.small
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(RowContainer, {
                                    className: "depth-two-row-container",
                                    children: /*#__PURE__*/ _jsx(BoxContainer, {
                                        children: depthData.four && depthData.four.items.map((menu)=>/*#__PURE__*/ _jsx(Link, {
                                                href: "/categories?id=".concat(menu.id),
                                                children: /*#__PURE__*/ _jsx(MenuColumn, {
                                                    data: menu,
                                                    onColumnClick: ()=>{
                                                        categoryMenuMixpanel("four", menu.name, "/categories?id=".concat(menu.id));
                                                    },
                                                    isActive: false,
                                                    suffix: true
                                                }, menu.id)
                                            }, menu.id))
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
